/**
 * [[include:migration.md]] 
 */
export class Migration {
}